module.exports = __webpack_public_path__ + "img/selected_meal.77be3bda.svg";